import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { store } from './redux/store';
import theme from './theme';
import App from './App';
import './globals.css';
import './i18n';

/**
 * `ColorModeScript` sets Chakra's `chakra-ui-color-mode` cookie/attribute
 * before React hydrates so the first paint matches the user's stored
 * pick — no flash of the wrong theme. The `type="cookie"` + `nonce` play
 * that Chakra offers for SSR isn't needed here (Vite SPA), so we use
 * the localStorage-backed default with our theme's `initialColorMode`.
 * A companion inline script in `index.html` sets the attribute even
 * earlier (before the JS bundle downloads) as a belt-and-suspenders.
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </Provider>
  </React.StrictMode>,
);
